import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function History() {
    const [sessions, setSessions] = useState([]);

    useEffect(() => {
        api.get("/exam/sessions").then((r) => setSessions(r.data));
    }, []);

    return (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
            <span className="overline text-primary">▮ History</span>
            <h1 className="mt-2 font-heading font-black text-4xl tracking-tighter">Your exam sessions</h1>

            <div className="mt-8 border border-border rounded-sm divide-y divide-border">
                {sessions.length === 0 && (
                    <div className="p-10 text-center text-sm text-muted-foreground">No sessions yet.</div>
                )}
                {sessions.map((s) => (
                    <Link key={s.id} data-testid={`history-row-${s.id}`}
                        to={s.status === "submitted" ? `/result/${s.id}` : `/exam/${s.id}`}
                        className="flex items-center justify-between p-4 hover:bg-accent/40 transition-colors">
                        <div>
                            <div className="font-mono text-sm">{s.exam} · {s.subjects.join(", ")} · {s.question_ids.length}Q</div>
                            <div className="text-xs text-muted-foreground mt-0.5">
                                Started {new Date(s.started_at).toLocaleString()} · {s.difficulty}
                            </div>
                        </div>
                        <span className={`overline text-[10px] px-2 py-1 rounded-sm border ${s.status === "submitted" ? "border-green-600 text-green-600" : "border-primary text-primary"}`}>
                            {s.status}
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    );
}
